import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';

function NotFound(): JSX.Element {
  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            height: '100vh'
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center'
            }}
          >
            <Typography variant="h1" component="h1" color="#112f5f" sx={{}}>
              404
            </Typography>
            <Typography
              variant="h3"
              component="h3"
              color="primary"
              gutterBottom
              sx={{ fontSize: '1.8rem', fontWeight: 'bold' }}
            >
              OOPS! NOTHING WAS FOUND
            </Typography>
            <Typography
              variant="h5"
              component="h5"
              gutterBottom
              sx={{ fontSize: '1rem' }}
            >
              The page you are looking for might have been removed had its name
              changed or is temporarily unavailable.
            </Typography>
            <a href="/" style={{ textDecoration: 'none' }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  m: 1,

                  borderRadius: 5
                }}
              >
                Return to Homepage
              </Button>
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default NotFound;
